<template>
  <div>
    <div class="row g-3">
      <div class="form-group col">
        <label for="contactName" class="form-label">
          <span data-bs-toggle="tooltip"
                :data-bs-title="label.includes('Seller') ? $t('tooltips.contactSellerName') : $t('tooltips.contactBuyerName')"
                class="badge ehw-green">{{ btNumbers[0].number }}</span>{{ $t('form.contactName') }}
        </label>
        <input
            id="contactName"
            type="text"
            v-model="localContact.name"
            @blur="emitUpdate"
            class="form-control"
            :required="!localContact.orgUnit"
        />
      </div>
      <div class="form-group col">
        <label for="contactOrgUnit" class="form-label"><span data-bs-toggle="tooltip"
                                                             :data-bs-title="label.includes('Seller') ? $t('tooltips.contactSellerName') : $t('tooltips.contactBuyerName')"
                                                             class="badge ehw-green">{{ btNumbers[0].number }}</span>{{ $t('form.contactOrgUnit') }}</label>
        <input
            id="contactOrgUnit"
            v-model="localContact.orgUnit"
            @blur="emitUpdate"
            class="form-control"
            :required="!localContact.name"
        />
      </div>
    </div>
    <div class="row g-3 mt-2">
      <div class="form-group col">
        <label for="contactEmail" class="form-label">
          <span data-bs-toggle="tooltip"
                :data-bs-title="label.includes('Seller') ? $t('tooltips.contactSellerEmail') : $t('tooltips.contactBuyerEmail')"
                class="badge ehw-green">{{ btNumbers[1].number }}</span>{{ $t('form.contactEmail') }}
        </label>
        <input
            id="contactEmail"
            type="email"
            v-model="localContact.emailAddress"
            @blur="emitUpdate"
            class="form-control"
            required
        />
      </div>
      <div class="form-group col">
        <label for="contactPhone" class="form-label">
          <span data-bs-toggle="tooltip"
                :data-bs-title="label.includes('Seller') ? $t('tooltips.contactSellerPhone') : $t('tooltips.contactBuyerPhone')"
                class="badge ehw-green">{{ btNumbers[2].number }}</span>{{ $t('form.contactPhone') }}
        </label>
        <input
            id="contactPhone"
            type="tel"
            v-model="localContact.phoneNo"
            @blur="emitUpdate"
            class="form-control"
            required
        />
      </div>
    </div>
  </div>
</template>

<script>
import Contact from '../../models/Contact';

const sellerBtNumbers = [
  {
    "number": "BT-41",
    "description": "Enter the contact person's name for inquiries."
  },
  {
    "number": "BT-43",
    "description": "Enter the contact person's email address."
  },
  {
    "number": "BT-42",
    "description": "Enter the contact person's phone number."
  },
]

const buyersBtNumbers = [
  {
    "number": "BT-56",
    "description": "Enter the contact person's name for inquiries."
  },
  {
    "number": "BT-58",
    "description": "Enter the contact person's email address."
  },
  {
    "number": "BT-67",
    "description": "Enter the contact person's phone number."
  },
]

export default {
  props: {
    contact: {
      type: Object,
      default: () => new Contact({})
    },
    label: String
  },
  data() {
    return {
      localContact: this.contact instanceof Contact ? this.contact : new Contact(this.contact || {})
    };
  },
  methods: {
    emitUpdate() {
      this.$emit('update-contact', this.localContact);
    }
  },
  computed: {
    btNumbers() {
      return this.label.includes('Seller') ? sellerBtNumbers : buyersBtNumbers;
    }
  },
  watch: {
    contact: {
      immediate: true,
      handler(newVal) {
        Object.assign(this.localContact, newVal);
        console.log("Contact updated:", this.localContact);
      }
    }
  }
};
</script>

<style scoped>
.form-label {
  display: flex;
  align-items: center;
  gap: 6px;
}
</style>
